var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationBigIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 107,
    viewBox: "0 0 97 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.9833 35.8108C78.9833 27.3223 75.8223 19.1816 70.1948 13.1794C64.5678 7.17717 56.936 3.80518 48.9781 3.80518C41.0202 3.80518 33.3883 7.17717 27.7612 13.1794C22.1341 19.1816 18.9728 27.3223 18.9728 35.8108C18.9728 73.1508 3.97021 83.8192 3.97021 83.8192H93.986C93.986 83.8192 78.9833 73.1508 78.9833 35.8108Z",
    stroke: "#454545",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6304 98.822C56.7513 100.338 55.4895 101.596 53.9708 102.47C52.4525 103.345 50.7312 103.805 48.9789 103.805C47.2266 103.805 45.5053 103.345 43.987 102.47C42.4688 101.596 41.2065 100.338 40.3274 98.822",
    stroke: "#454545",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBigIcon);
export default __webpack_public_path__ + "static/media/notification_big_icon.8512fcac2b6b1ed24e01b888ef937c19.svg";
export { ForwardRef as ReactComponent };